var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"search-control ui-btn",class:{
    'search-control--fade': _vm.getShouldFade
  },attrs:{"aria-label":"Show the search input"},on:{"click":function($event){$event.stopPropagation();return _vm.emitClick.apply(null, arguments)}}},[(_vm.active)?_c('Cross',{staticClass:"search-control__close-icon"}):_c('Spyglass',{staticClass:"search-control__search-icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }